(function($, undefined) {
	
	'use strict';

	var exportJson = function () {
		var selected = $('.mg2_manageGenList_item').filter(function() {
			return $('input[name="mg2_manageGenList_item_checkbox"]', $(this)).is(':checked');
		});
		
		var json = {};
		
		selected.each(function() {
			var info = $('.mg2_manageGenList_item_info', $(this));
			var id = info.attr('data-id');
			var total = parseInt(info.attr('data-attr-total'));
			var extraData = info.attr('data-extradata');
			
			json[id] = {
				id: id,
				extraData: extraData
			};
			
			for (var i = 0; i <= total; i++) {
				if (info.attr('field' + i) !== undefined) {
					json[id]['field'+i] = info.attr('field' + i);
				}
			}
		});
		
		$('.mg2_manageGenList_result').html(JSON.stringify(json));
	};
	
	var importJson = function () {
		var jsonString = $('.mg2_manageGenList_import').val();
		var json = JSON.parse(jsonString);
		var count = 0;
		var total = Object.keys(json).length;
		
		for(var key in json) {
			var data = {
				extraData: json[key].extraData,
				ajax: true
			};
			
			for(var k = 1; k <= 26;k++) {
				data['field'+k] = json[key]['field'+k];
			}
			
			//Fetch id for duplicates
			$('.mg2_manageGenList_adminid').each(function () {
				if ($(this).html() === json[key].field11) {
					data.id = $(this).closest('.mg2_manageGenList_item').find('.mg2_manageGenList_item_info').attr('data-id');
				}
			});
			
			console.log(data);
			
			//ajax
			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: data,
				success: function(response) {
					count++;
					
					if (count === total) {
						alert('Done!');
					}
				}
			});
		}
	};
	
	var init = function () {
		exportJson();
		
		$('input[name="mg2_manageGenList_item_checkbox"]').change(exportJson);
		$('.mg2_manageGenList_import_btn').click(importJson);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
